import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';

import { useIntl } from '../../../util/reactIntl';
import { useSignInContext } from '../../../context/SignInContext';
import { clearLoginError, login } from '../../../ducks/auth.duck';
import { createResourceLocatorString } from '../../../util/routes';
import routeConfiguration from '../../../routing/routeConfiguration';

import SignInDrawer from './SignInDrawer';

const GlobalSignInDrawerComponent = ({
  history,
  loginInProgress,
  loginError,
  onSubmitLogin,
  onClearLoginError,
}) => {
  const intl = useIntl();
  const { isOpen, defaultToLogin, fullScreenOnMobile, modeVersion, closeSignIn } =
    useSignInContext();

  return (
    <SignInDrawer
      isOpen={isOpen}
      onClose={closeSignIn}
      intl={intl}
      onSubmitLogin={onSubmitLogin}
      loginInProgress={loginInProgress}
      loginError={loginError}
      onClearLoginError={onClearLoginError}
      defaultToLogin={defaultToLogin}
      fullScreenOnMobile={fullScreenOnMobile}
      modeVersion={modeVersion}
    />
  );
};

const mapStateToProps = state => {
  const { loginInProgress, loginError = null } = state.auth || {};
  return {
    loginInProgress,
    loginError,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmitLogin: ({ email, password }) => {
    const history = ownProps?.history;
    return dispatch(login(email, password)).then(user => {
      if (user?.attributes && history) {
        const menopauseItems =
          user.attributes?.profile?.protectedData?.onboardingData?.menopauseItems;
        const path =
          Array.isArray(menopauseItems) && menopauseItems.includes('familyProgram')
            ? createResourceLocatorString('Homepage', routeConfiguration(), {}, {})
            : createResourceLocatorString('MenopauseResourcePage', routeConfiguration(), {}, {});
        history.push(path);
      }
    });
  },
  onClearLoginError: () => dispatch(clearLoginError()),
});

const GlobalSignInDrawer = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(GlobalSignInDrawerComponent);

export default GlobalSignInDrawer;
